const StorageKeys = {
    urlAdvisees: 'urlAdvisees'
};
export default StorageKeys;
